var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 5v5h5v2h-7V5zM4.3 17.2l1.6 1.2-3.1 4.2-1.6-1.2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 1C5.5 1 1 5.5 1 11s4.5 10 10 10 10-4.5 10-10S16.5 1 11 1m0 2c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8M4.3-.7 5.7.7l-5 5-1.4-1.4z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m17.7 17.2 3.1 4.2-1.6 1.2-3.1-4.2zM17.7-.7l5 5-1.4 1.4-5-5z"
})));
export default SvgClock;